var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBulbIconSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon-svg",
    d: "M9.5 5.00007C9.50555 4.19683 9.29599 3.40675 8.89309 2.71185C8.49018 2.01695 7.90862 1.44255 7.20877 1.0483C6.50892 0.654055 5.7163 0.454319 4.91319 0.469834C4.11009 0.485348 3.32577 0.715547 2.64167 1.13653C1.95757 1.55752 1.39862 2.15394 1.02286 2.86389C0.647093 3.57383 0.468207 4.37142 0.504773 5.17384C0.541338 5.97627 0.792021 6.75428 1.2308 7.4271C1.66957 8.09993 2.28045 8.64305 3 9.00007V10.5001C3 10.6327 3.05268 10.7599 3.14645 10.8536C3.24022 10.9474 3.36739 11.0001 3.5 11.0001H6.5C6.63261 11.0001 6.75979 10.9474 6.85355 10.8536C6.94732 10.7599 7 10.6327 7 10.5001V9.00007C7.74748 8.6318 8.37744 8.06236 8.81907 7.35574C9.26071 6.64912 9.49652 5.83334 9.5 5.00007V5.00007Z",
    stroke: "#4D4745",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "icon-svg",
    d: "M3 13.5H7",
    stroke: "#4D4745",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulbIconSmall);
export default __webpack_public_path__ + "static/media/BulbIconSmall.f7b76b00eef1f6a41103726163081e61.svg";
export { ForwardRef as ReactComponent };